import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import MovingColumnCards from './MovingColumnCards';
import * as action from './store/ProductCP.action';

function RenderProductCpColumnsTable({
  columns,
  index,
  handleEditColumn,
  handleDelete,
  handleActiveInactive,
  handleSelectAllColumnOfTabs,
  selectedColIds,
  selectedAll,
  handleCheckOdColumns,
  disableButtons,
  tabId,
}) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const {
    Users: { logInRights },
  } = useSelector((reducer) => reducer);
  const [state, setState] = useState({
    columnsState: [],
  });
  const { columnsState } = state;
  useEffect(() => {
    if (Array.isArray(columns)) {
      setState({ ...state, columnsState: columns });
    }
  }, [columns]);

  const { CheckActionPermission } = useComponent();
  const productAddEditAccess = CheckActionPermission(logInRights, 'criticalPath', 'product', 'addEdit');

  function swapArrayLocs(arr, index1, index2) {
    const temp = arr[index1];
    arr[index1] = arr[index2];
    arr[index2] = temp;
    return arr;
  }

  const moveColumn = async (movedCardIndex, toCardIndex) => {
    const cloneAllTabs = columnsState;
    const currList = swapArrayLocs(cloneAllTabs, movedCardIndex, toCardIndex);

    setState((prevCards) => ({
      ...prevCards,
      columnsState: currList,
    }));
  };

  const callApi = async () => {
    const newSequence = [];
    const insertObj = {
      productCPId: id,
      tabId,
      fromMovingCards: true,
    };
    columnsState?.forEach((vl, ind) => {
      newSequence.push({ _id: vl?._id, sequence: ind, name: vl?.name });
    });
    insertObj.columns = newSequence;
    const res = await dispatch(action.addColumnsToProductCpCard(insertObj, t));
    if (res) {
      dispatch(action.getAllProductcpTabs({ productCPId: id }));
    }
  };

  const renderTableColumns = (ColumnItem, ColumnIndex) => {
    return (
      <MovingColumnCards
        col={ColumnItem}
        colIdx={ColumnIndex}
        handleEditColumn={handleEditColumn}
        moveColumn={moveColumn}
        id={ColumnItem?._id}
        handleDelete={handleDelete}
        handleActiveInactive={handleActiveInactive}
        selectedColIds={selectedColIds}
        handleCheckOdColumns={handleCheckOdColumns}
        disableButtons={disableButtons}
        key={ColumnItem?._id}
        index={ColumnIndex}
        callApi={callApi}
      />
    );
  };

  return (
    <table className="table common-custom-table xs-layout-fixed m-0">
      <thead>
        <tr>
          <th className="w-50px">
            <div className="common-checkbox no-label margin-auto">
              <input
                type="checkbox"
                onChange={handleSelectAllColumnOfTabs}
                name={`productCpCheck_${index}`}
                id={`productCpCheck_${index}`}
                checked={selectedAll}
                disabled={disableButtons || isEmpty(columnsState)}
              />
              <label htmlFor={`productCpCheck_${index}`} className="chklabel">
                <span />
              </label>
            </div>
          </th>
          <th className="w-xs-150px">{t('PRODUCT_CRITICAL_PATH.RENDER_PRODUCT_CP_COLUMN.COLUMN_NAME')}</th>
          <th className="w-xs-150px">{t('PRODUCT_CRITICAL_PATH.RENDER_PRODUCT_CP_COLUMN.VISIBLE_TO_SUPPLIER')}</th>
          <th className="w-xs-150px">{t('PRODUCT_CRITICAL_PATH.RENDER_PRODUCT_CP_COLUMN.ASSIGNEE')}</th>
          <th className="w-xs-150px">{t('PRODUCT_CRITICAL_PATH.RENDER_PRODUCT_CP_COLUMN.TYPE')}</th>
          <th className="w-xs-150px">{t('PRODUCT_CRITICAL_PATH.RENDER_PRODUCT_CP_COLUMN.OPTIONAL_REQUIRED')}</th>
          {productAddEditAccess && <th className="w-xs-150px">{t('PRODUCT_CRITICAL_PATH.RENDER_PRODUCT_CP_COLUMN.ACTION')}</th>}
        </tr>
      </thead>
      <tbody>
        <DndProvider backend={HTML5Backend}>
          {Array.isArray(columnsState) && columnsState.length > 0 ? (
            columnsState?.map((col, colIdx) => {
              return renderTableColumns(col, colIdx);
            })
          ) : (
            <tr>
              <td className=" text-center" colSpan="7">
                <span>{t('PRODUCT_CRITICAL_PATH.RENDER_PRODUCT_CP_COLUMN.NO_COLUMNS_FOUND')}</span>
              </td>
            </tr>
          )}
        </DndProvider>
      </tbody>
    </table>
  );
}
export default RenderProductCpColumnsTable;
